import { Image } from "react-bootstrap";
import {
     TeamMembersSection,
     FounderGreatNonprofits,
     FounderImage,
     FounderDetails,
     FounderName,
     FounderDesignation,
     FounderText,
     SubTeamMember,
     TeamMember,
     MemberImage,
     MemberText,
} from '../membersStyle';
import OliviaKhalili from '../../../../assests/images/olivia_khalili.webp'
import Perla from '../../../../assests/images/perla.webp';
import { useEffect, useState } from "react";
import { aboutMembersHandler } from "../../../../redux/slices/members/about-members";
import { useSelector,useDispatch } from "react-redux";

const TeamMembers = () => {
     const [teamMemberList, setTeamMemberList] = useState<any>([]);
     const [isReadMoreArray, setIsReadMoreArray] = useState<boolean[]>([]);
 
     const aboutMembersData = useSelector((state:any) => state?.aboutMembers?.data)
     const dispatch:any = useDispatch();
 
     useEffect(() => {
         dispatch(aboutMembersHandler());
     }, []);
 
     useEffect(() => {
         if(aboutMembersData?.data){
             setTeamMemberList(aboutMembersData.data.teamMembers);
             setIsReadMoreArray(new Array(aboutMembersData.data.teamMembers.length).fill(true));
         }
     }, [aboutMembersData]);
 
     const toggleReadMore = (index: number) => {
         setIsReadMoreArray(prevState => {
             const newState = [...prevState];
             newState[index] = !newState[index];
             return newState;
         });
     };
 
     return (
         <TeamMembersSection>
             {teamMemberList.length > 0 && (
                 <FounderGreatNonprofits>
                     <FounderImage><Image src={Perla} alt={teamMemberList[0]?.profileImg} /></FounderImage>
                     <FounderDetails>
                         <FounderName>{teamMemberList[0]?.name}</FounderName>
                         <FounderDesignation>{teamMemberList[0]?.profession}</FounderDesignation>
                         <FounderText><strong>{teamMemberList[0]?.name}, </strong>{teamMemberList[0]?.about}</FounderText>
                     </FounderDetails>
                 </FounderGreatNonprofits>
             )}
             <SubTeamMember>
                 {teamMemberList?.slice(1)?.map((member: any, index: number) => (
                     <TeamMember key={index+1}>
                         <MemberImage>
                             <Image src={OliviaKhalili} alt={member.profileImg}/>
                         </MemberImage>
                         <MemberText>
                             <strong>{`${member.name} ${member.profession} `}</strong>
                             {isReadMoreArray[index + 1] ? member.about.slice(0, 135) : member.about}
                             {member.about && member.about.length > 155 && 
                                 <a href="#!" onClick={() => toggleReadMore(index + 1)}>
                                    <span>
                                    {isReadMoreArray[index + 1] ? ' ...Read More' : ' Read Less'}
                                    </span>
                                 </a>
                             }
                         </MemberText>
                     </TeamMember>
                 ))}
             </SubTeamMember>
         </TeamMembersSection>
     );
 };
export default TeamMembers; 